module.exports = __webpack_public_path__ + "static/media/Bosch_Logo.a39a6338.png";